import Filter from '@/scripts/components/Filter';
import {scrollScene, toggleClass} from '@/scripts/utils/scroll-scenes';
import {getCssVar} from '@/scripts/utils/helpers';
import loaded from '@/scripts/utils/loaded';


const selectors = {
    imageText: '.image-with-text',
    trigger: '.trigger-element',
    imageWithTextImg: '.image-with-text__image img',
    homeHeroBG: '#home__hero__background',
    shopItems: '.shop-item',
};

const classes = {
    hoverClass: 'hover'
}

// GSAP's circ.in and its reverse (circ.out) as CSS curves.
const CIRC_IN = 'cubic-bezier(0.6, 0.04, 0.98, 0.335)';
const CIRC_OUT = 'cubic-bezier(0.075, 0.82, 0.165, 1)';

class Index {

    initMediaQuery = () => {
        const small = getCssVar('small') || '750px';
        const medium = getCssVar('medium') || '1040px';
        this.desktopMq = window.matchMedia(`(min-width: ${small})`);
        this.mediumMq = window.matchMedia(`(min-width: ${medium})`);
    };

    setUpShop = () => {
        if (this.mediumMq.matches) {
            const shopItems = document.querySelectorAll(selectors.shopItems);
            shopItems.forEach((shopItem) => {
                shopItem.addEventListener('mouseenter', function (e) {
                    shopItems.forEach((item) => item.classList.remove(classes.hoverClass));
                    const hovered = e.target.closest(selectors.shopItems);
                    if (hovered) {
                        hovered.classList.add(classes.hoverClass);
                    }
                });
            });
        }
    }

    indexAnimations = () => {
        if (document.getElementById('home-filter-title')) {
            scrollScene({
                trigger: '#home-filter-title',
                hook: 0.5,
                offset: -100,
                reverse: false,
                onToggle: toggleClass('#home-filter-title', 'fade-in'),
            });
        }

        if (document.getElementById('home-filter-select')) {
            scrollScene({
                trigger: '#home-filter-select',
                hook: 0.5,
                offset: -100,
                reverse: false,
                onToggle: toggleClass('#home-filter-select', 'fade-in'),
            });
        }

        if (document.querySelector('.discovery__container')) {
            scrollScene({
                trigger: '.discovery__container',
                hook: 1,
                offset: 100,
                reverse: false,
                onToggle: toggleClass('.discovery__container', 'fade-in'),
            });
        }

        if (document.getElementById('hero-triggerhook')) {
            if (document.getElementById('home-fixed-scroll')) {
                scrollScene({
                    trigger: '#hero-triggerhook',
                    hook: 0,
                    onToggle: toggleClass('#home-fixed-scroll', 'relative'),
                });

                scrollScene({
                    trigger: '#hero-triggerhook',
                    hook: 0,
                    offset: -40,
                    onToggle: toggleClass('#home-fixed-scroll', 'text-revealed'),
                });
            }

            if (document.getElementById('home-fixed-cover')) {
                scrollScene({
                    trigger: '#hero-triggerhook',
                    hook: 0.8,
                    onToggle: toggleClass('#home-fixed-cover', 'hidden'),
                });
            }
        }

        if (document.getElementById('home-discovery')) {
            scrollScene({
                trigger: '#home-discovery',
                hook: 1,
                onToggle: toggleClass('.footer', 'relative'),
            });
        }

        // Was a 1s GSAP tween (circ.in) played forward once #home-discovery reaches the viewport
        // bottom and reversed when scrolling back; a CSS transition does the same. Reversing a
        // circ.in tween traces circ.out, so the way back uses that curve.
        const shop = document.getElementById('home__shop');
        if (shop && document.getElementById('home-discovery')) {
            shop.style.transform = 'translateY(0px)';
            shop.style.opacity = '1';
            scrollScene({
                trigger: '#home-discovery',
                hook: 1,
                onToggle: (active) => {
                    const ease = active ? CIRC_IN : CIRC_OUT;
                    shop.style.transition = `transform 1s ${ease}, opacity 1s ${ease}`;
                    shop.style.transform = active ? 'translateY(-80px)' : 'translateY(0px)';
                    shop.style.opacity = active ? '0.01' : '1';
                },
            });
        }

        if (document.getElementById('home-story')) {
            scrollScene({
                trigger: '#home-story',
                hook: 1,
                offset: 100,
                reverse: false,
                onToggle: toggleClass('#home-story', 'fade-in'),
            });
        }

        // Was a GSAP tween scrubbed by scroll: background-position-y 100% → 50% with circ.in easing
        // over one viewport height from #hero-triggerhook reaching the viewport bottom.
        const shopImages = document.querySelectorAll('.shop-item__bg');
        if (shopImages.length && document.getElementById('hero-triggerhook')) {
            scrollScene({
                trigger: '#hero-triggerhook',
                hook: 1,
                duration: '100%',
                onProgress: (progress) => {
                    const eased = 1 - Math.sqrt(1 - progress * progress);
                    const position = `${100 - 50 * eased}%`;
                    shopImages.forEach((image) => {
                        image.style.backgroundPositionY = position;
                    });
                },
            });
        }

        if (document.getElementById('home-filter-select')) {
            scrollScene({
                trigger: '#home-filter-select',
                hook: 0.85,
                offset: 200,
                reverse: false,
                onToggle: toggleClass('#home-filter-bottles', 'fade-in'),
            });
        }
    };

    setUpFilter = () => {
        new Filter();
    };

    constructor() {
        this.initMediaQuery();
        this.indexAnimations();
        this.setUpFilter();
        this.setUpShop();
    }
}

loaded(() => new Index());
